import script from "./HeroLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroLanding.vue?vue&type=script&setup=true&lang=js"

import "./HeroLanding.vue?vue&type=style&index=0&id=72656b67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72656b67"]])

export default __exports__